import { configureStore } from '@reduxjs/toolkit';
import userReducer from './userSlice';
import authReducer from './authSlice'; // NEW

export const store = configureStore({
  reducer: {
    user: userReducer,
    auth: authReducer, // NEW - for seller data
  },
});

export default store;